"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UserGeneralHandler", {
    enumerable: true,
    get: function() {
        return UserGeneralHandler;
    }
});
const _conditionHelpers = require("~/helpers/conditionHelpers");
const _dbHelpers = require("~/helpers/dbHelpers");
const _generic = require("~/db/field-handler/handlers/generic");
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
const _models = require("~/models");
let UserGeneralHandler = class UserGeneralHandler extends _generic.GenericFieldHandler {
    async filter(knex, filter, column, options) {
        var _options_customWhereClause;
        const { alias, context } = options;
        let val = filter.value;
        const field = (_options_customWhereClause = options.customWhereClause) != null ? _options_customWhereClause : alias ? `${alias}.${column.column_name}` : column.column_name;
        (0, _conditionHelpers.handleCurrentUserFilter)(context, {
            column,
            filter,
            setVal: (newVal)=>val = newVal
        });
        return await this.handleFilter({
            val,
            sourceField: field
        }, {
            knex,
            filter,
            column
        }, options);
    }
    async parseUserInput(params) {
        var _params_options_context;
        const userIds = [];
        let evalValue = params.value;
        if (typeof evalValue === 'string' && /^\s*[{[]/.test(evalValue)) {
            try {
                evalValue = JSON.parse(evalValue);
            } catch (e) {}
        }
        const baseUsers = await _models.BaseUser.getUsersList((_params_options_context = params.options.context) != null ? _params_options_context : params.options.baseModel.context, {
            base_id: params.options.baseModel.model.base_id,
            // deleted user may still exists on some fields
            // it's still valid as a historical record
            include_ws_deleted: true,
            include_internal_user: true
        });
        if (typeof evalValue === 'object') {
            const users = Array.isArray(evalValue) ? evalValue : [
                evalValue
            ];
            for (const userObj of users){
                const user = (0, _extractProps.extractProps)(userObj, [
                    'id',
                    'email'
                ]);
                try {
                    if ('id' in user) {
                        const u = baseUsers.find((u)=>u.id === user.id);
                        if (!u) {
                            _catchError.NcError.invalidValueForField({
                                value: params.value,
                                column: params.column.title,
                                type: params.column.uidt,
                                reason: `User with id '${user.id}' is not part of this workspace`
                            });
                        }
                        userIds.push(u.id);
                    } else if ('email' in user) {
                        // skip null input
                        if (!user.email) continue;
                        // trim extra spaces
                        user.email = user.email.trim();
                        // skip empty input
                        if (user.email.length === 0) continue;
                        const u = baseUsers.find((u)=>u.email === user.email);
                        if (!u) {
                            _catchError.NcError.invalidValueForField({
                                value: params.value,
                                column: params.column.title,
                                type: params.column.uidt,
                                reason: `User with email '${user.email}' is not part of this workspace`
                            });
                        }
                        userIds.push(u.id);
                    } else {
                        _catchError.NcError.invalidValueForField({
                            value: params.value,
                            column: params.column.title,
                            type: params.column.uidt,
                            reason: `Invalid user object`
                        });
                    }
                } catch (e) {
                    _catchError.NcError.invalidValueForField({
                        value: params.value,
                        column: params.column.title,
                        type: params.column.uidt,
                        reason: e.message
                    });
                }
            }
        } else if (typeof evalValue === 'string') {
            const users = evalValue.split(',').map((u)=>u.trim());
            for (const user of users){
                try {
                    if (user.length === 0) continue;
                    if (user.includes('@')) {
                        const u = baseUsers.find((u)=>u.email === user);
                        if (!u) {
                            _catchError.NcError.invalidValueForField({
                                value: params.value,
                                column: params.column.title,
                                type: params.column.uidt,
                                reason: `User with email '${user}' is not part of this workspace`
                            });
                        }
                        userIds.push(u.id);
                    } else {
                        const u = baseUsers.find((u)=>u.id === user);
                        if (!u) {
                            _catchError.NcError.invalidValueForField({
                                value: params.value,
                                column: params.column.title,
                                type: params.column.uidt,
                                reason: `User with id '${user}' is not part of this workspace`
                            });
                        }
                        userIds.push(u.id);
                    }
                } catch (e) {
                    if (e instanceof _catchError.NcBaseErrorv2) {
                        throw e;
                    }
                    _catchError.NcError.invalidValueForField({
                        value: params.value,
                        column: params.column.title,
                        type: params.column.uidt,
                        reason: e.message
                    });
                }
            }
        } else {
            params.options.logger.error(`${evalValue} is not a valid user input`);
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt,
                reason: `Invalid user object`
            });
        }
        if (userIds.length === 0) {
            evalValue = null;
        } else {
            var _params_column_meta;
            const userSet = new Set(userIds);
            if (userSet.size !== userIds.length) {
                _catchError.NcError.invalidValueForField({
                    value: params.value,
                    column: params.column.title,
                    type: params.column.uidt,
                    reason: 'Duplicate users not allowed for user field'
                });
            }
            if ((_params_column_meta = params.column.meta) == null ? void 0 : _params_column_meta.is_multi) {
                evalValue = userIds.join(',');
            } else {
                if (userIds.length > 1) {
                    _catchError.NcError.invalidValueForField({
                        value: params.value,
                        column: params.column.title,
                        type: params.column.uidt,
                        reason: `Multiple users not allowed for '${params.column.title}'`
                    });
                } else {
                    evalValue = userIds[0];
                }
            }
        }
        return {
            value: evalValue
        };
    }
    async filterLikeNlike(args, rootArgs, options) {
        const { sourceField } = args;
        const { val } = args;
        const { knex, filter, column } = rootArgs;
        const { context } = options;
        // get column name for CreatedBy, LastModifiedBy
        column.column_name = await (0, _dbHelpers.getColumnName)(context, column);
        const baseUsers = await _models.BaseUser.getUsersList(context, {
            base_id: column.base_id,
            include_internal_user: true
        });
        const users = baseUsers.filter((user)=>{
            const filterVal = val.toLowerCase();
            if (filterVal.startsWith('%') && filterVal.endsWith('%')) {
                return (user.display_name || user.email).toLowerCase().includes(filterVal.substring(1, filterVal.length - 1));
            } else if (filterVal.startsWith('%')) {
                return (user.display_name || user.email).toLowerCase().endsWith(filterVal.substring(1));
            } else if (filterVal.endsWith('%')) {
                return (user.display_name || user.email).toLowerCase().startsWith(filterVal.substring(0, filterVal.length - 1));
            }
            return (user.display_name || user.email).toLowerCase().includes(filterVal.toLowerCase());
        });
        const finalStatement = this.replaceDelimitedWithKeyValue({
            knex,
            needleColumn: sourceField,
            stack: users.map((user)=>({
                    key: user.id,
                    value: user.display_name || user.email
                }))
        });
        if (filter.comparison_op === 'like') {
            return this.singleLineTextHandler.filterLike({
                val,
                sourceField: knex.raw(finalStatement)
            }, rootArgs, options);
        } else {
            return this.singleLineTextHandler.filterNlike({
                val,
                sourceField: knex.raw(finalStatement)
            }, rootArgs, options);
        }
    }
    replaceDelimitedWithKeyValue(param) {
        const { knex, needleColumn, stack } = param;
        return stack.reduce((acc, each)=>{
            const qb = knex.raw(`REPLACE(${acc}, ?, ?)`, [
                each.key,
                each.value
            ]);
            return qb.toQuery();
        }, knex.raw(`??`, [
            needleColumn
        ]).toQuery());
    }
    constructor(...args){
        super(...args), this.singleLineTextHandler = new _generic.GenericFieldHandler();
    }
};
